import { render, staticRenderFns } from "./AddThingsPage.vue?vue&type=template&id=38b1a516&scoped=true&"
import script from "./AddThingsPage.vue?vue&type=script&lang=ts&"
export * from "./AddThingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddThingsPage.vue?vue&type=style&index=0&id=38b1a516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1a516",
  null
  
)

export default component.exports